import React from 'react'
import { useTranslation } from 'react-i18next'

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation()

  const toggleLanguage = () => {
    const newLang = i18n.language === 'pl' ? 'en' : 'pl'
    i18n.changeLanguage(newLang)
  }

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center px-3 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors"
      aria-label="Change language"
    >
      <span className="mr-2 text-lg">
        {i18n.language === 'pl' ? '🇵🇱' : '🇺🇸'}
      </span>
      {i18n.language === 'pl' ? 'EN' : 'PL'}
    </button>
  )
}